"use strict"

import React, { useEffect, useState } from "react"

import { toSelectArray } from "../modals/StartRunModal/utils"
import { ChunkedRunInfo } from "./RunDetailsDiv"

export default function RunMetadataCode({ metadata, chunkSize = 2, view = true, intl }) {
  const [show, setShow] = useState(true)
  useEffect(() => {
    view !== show && setShow(view)
  }, [])
  return (
    <>
      <hr />
      <div style={{ padding: "10px" }}>
        <h5 style={{ marginBottom: "20px", cursor: "pointer" }} onClick={() => setShow(!show)}>
          <span className={`fa fa-caret-${show ? "down" : "right"}`} />
          &nbsp;
          <b>{intl.formatMessage({ id: "general.metadata", defaultMessage: "Metadata" })}</b>
        </h5>
        {show && (
          <ChunkedRunInfo
            intl={intl}
            arr={Object.entries(metadata || {}).map(([k, v]) => ({
              value: (Array.isArray(v) ? toSelectArray(v).join("\n") : v) || "-",
              id: `fermmanagement.${k}`,
              description: k,
            }))}
            chunkSize={chunkSize}
          />
        )}
      </div>
    </>
  )
}
